module.exports = __webpack_public_path__ + "h5/img/icon_home_y.263be8e8.png";